import { chakra, Checkbox, Flex } from "@chakra-ui/react";
import { Messages } from "../../../core/api";

interface POCItemHeaderProps {
  item: Messages["PatientDocumentPOCItem"];
  isChecked: boolean;
  isRequired: boolean;
  readonly: boolean;
  onTaskCheck: (name: string) => void;
}

export function POCItemHeader({
  item,
  isChecked,
  isRequired,
  readonly,
  onTaskCheck,
}: POCItemHeaderProps) {
  return (
    <HeaderContainer>
      <Checkbox
        isChecked={isChecked}
        isDisabled={readonly}
        isRequired={isRequired}
        onChange={() => {
          onTaskCheck(item.name);
        }}
      >
        {item.name}
      </Checkbox>
    </HeaderContainer>
  );
}

const HeaderContainer = chakra(Flex, {
  baseStyle: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: "bold",
  },
});
